module.exports = __webpack_public_path__ + "img/vedio_des_4.34b99ce5.jpg";